import React,{useCallback} from 'react'
import moment from 'moment'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { useSelector,useDispatch } from 'react-redux'
import { getCartToken, removeToken } from '../../../utilities/function/cartToken'
import { appInit, resetCart } from '../../../app/action'

export const VIEWCART_CLASSNAME = 'of-viewcart-connector'

let ViewcartConnector = (props) => {
  const {
    cartStatus,
    cartData
  } = useSelector(state => ({
    cartStatus: state.app.cartStatus,
    cartData: state.app.cartData
  }))
  const dispatch = useDispatch()
  const getNoItemsInCart = () => {
    if(cartData && cartData.items && cartData.items.length){
      return cartData.items.length
    }
    return 0
  }
  const { container, router, icon , text} = props
  const { history } = router

  const onClick = useCallback(() => {
    if(cartData && cartData.expiry && moment(cartData.expiry) && moment(cartData.expiry).isValid()){
      let diff = moment(cartData.expiry).diff(moment())
      if(diff<=0){
        removeToken()
        resetCart(dispatch)
        appInit(dispatch,history,true)
      }
    }
    history.push(`${history.location.pathname}?a=viewcart`)
  },[cartData,history,dispatch])
  const renderItemsInCart = () => {
    if (cartStatus && cartStatus === 'success' && getCartToken() !== 'undefined') {
      if (getNoItemsInCart() && getNoItemsInCart() > 0) {
        return (<span className={`${VIEWCART_CLASSNAME}__no-items`}>{getNoItemsInCart()}</span>)
      }
    }
    return (<></>)
  }

  return ReactDOM.createPortal(
    <span className={`${VIEWCART_CLASSNAME}__wrapper`} onClick={onClick}>
      <div className={`${VIEWCART_CLASSNAME}__icon-wrapper`}>
        <i className={`icon icon-of-${icon ? icon : 'cart-icon'}`}/>
        {renderItemsInCart()}
      </div>
      {text?<span className={`${VIEWCART_CLASSNAME}__text`}>{text}</span>:''}
    </span>
    , container)

}

ViewcartConnector.propTypes = {
  container: PropTypes.any,
  router: PropTypes.any,
  icon: PropTypes.string
}

export const RenderViewcartConnector = (props) => {
  const domlist = Array.from(document.querySelectorAll(`.${VIEWCART_CLASSNAME}`))
  const { router } = props
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const icon = el.getAttribute('data-icon')
      const text = el.getAttribute('data-text')
      return (<ViewcartConnector
        key={index}
        container={el}
        router={router}
        icon={icon}
        text={text}
      />)
    })
  }
  return (<></>)
}

RenderViewcartConnector.propTypes = {
  router: PropTypes.any
}